import "./AdminWorkspaces.css";

import * as m from "../../../../model/model";

import {
  createWorkspaceThunk,
  getWorkspacesThunk,
} from "../../../../store/slices/workspaceThunks";
import { useAppDispatch, useAppSelector } from "../../../../store";

import AdminWorkspacePanel from "./AdminWorkspacePanel";
import PromptModal from "../../../../modals/PromptModal";
import React from "react";
import { useModal } from "../../../../context/ModalContext";
import { workspaceActions } from "../../../../store/slices/workspaceSlice";

/**
 * 1. Create new workspace (name, description)
 * 2. List workspaces
 * 3. View and edit workspace
 * 4. Delete workspace
 * 5. Assign users to workspace
 * 6. Remove users from workspace
 * 7. Workspace users
 * 8. Workspace assignments
 * 9. Workspace progress
 * 10. Workspace reports
 * 11. Workspace settings
 * 12. Workspace logs
 * 13. Workspace history
 * 14. Workspace notifications (email, SMS, in-app)
 * 15. Workspace messages
 * 16. Workspace files
 * 17. Workspace links
 * 18. Workspace calendar?
 * 19. Workspace tasks
 * 20. Workspace quizzes
 * 21. Workspace surveys
 * 22. Workspace polls
 * 23. Workspace discussions
 * 24. Workspace chats
 * 25. Workspace video calls
 * 26. Workspace audio calls
 * 27. Workspace screen sharing
 * 28. Workspace whiteboard
 */
export default function AdminWorkspaces() {
  const workspaces = useAppSelector((state) => state.workspace.workspaces);
  const currentWorkspace = useAppSelector(
    (state) => state.workspace.currentWorkspace
  );
  const { showModal } = useModal();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getWorkspacesThunk());
  }, [dispatch]);

  const onClickNewWorkspace = () => {
    showModal(
      <PromptModal
        header="New Workspace"
        message="Enter workspace name"
        onConfirm={(name: string) => {
          dispatch(createWorkspaceThunk(name));
        }}
        onCancel={() => null}
      />
    );
  };

  const onClickWorkspace = (workspace: m.Workspace) => {
    dispatch(workspaceActions.setCurrentWorkspace(workspace));
  };

  return (
    <div className="workspaces-page">
      <div className="workspaces-header">
        <button className="loa-button" onClick={onClickNewWorkspace}>
          New Workspace
        </button>
      </div>
      <div className="workspaces-panel">
        <div className="workspaces-list">
          {workspaces.map((w) => (
            <div
              key={w.id}
              className={`workspace-item ${
                currentWorkspace?.id === w.id ? "selected" : ""
              }`}
              onClick={() => onClickWorkspace(w)}
            >
              {w.name}
            </div>
          ))}
        </div>
        <div className="workspace-view">
          <AdminWorkspacePanel />
        </div>
      </div>
    </div>
  );
}
